var moment = require("moment");

export function dateFormat(value) {
  if (
    moment(value, moment.ISO_8601, true).isValid() && isNaN(value) &&
    typeof value !== "boolean"
  )
    return (value = moment(value).format("LLL"));

  return value;
}
